import ApiService from '@/services/api.service'

const AreaService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/Areas/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    },  
    getAreas(parameter){
        const requestData = {
            method: 'get',
            url: "/Areas/",       
            params: {
                EmirateRecId:parameter.EmirateRecId
            }
          }       
          return ApiService.customRequest(requestData);
    },
    Add(data){
        return ApiService.post(`/Areas`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/Areas/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/Areas/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/Areas/${Id}`);
    }
  }


  
  export default AreaService;